export function stringifyStyles(styles) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$useImportant = _ref.useImportant,
    useImportant = _ref$useImportant === void 0 ? false : _ref$useImportant;
  return Object.keys(styles).reduce(function (acc, key) {
    return "".concat(acc).concat(key, ": ").concat(styles[key]).concat(useImportant ? ' !important' : '', "; ");
  }, '');
}
export function applyParentSelector(parentSelector, selector) {
  return selector.split(',').map(function (childSelector) {
    return ".".concat(parentSelector, " ").concat(childSelector.trim());
  }).join(', ');
}